<template>
  <div>
    <save-engagement-tool
      :pageHeadingInfo="pageHeadingInfo"
      :leftToolSummary="[]"
      :rightToolSummary="superRightToolSummary"
      :chartTabContent="superChartTabContent"
      :chartProperties="chartProperties"
      :selectedComponent="superSelectedComponent"
      :emptyChartMessage="emptyChartMessage"
      :chartData="chartGraphData"
      :fieldInfo="fieldInfo"
      @cancelInstance="cancelInstance"
      @saveInstance="saveInstance"
      @onBack="onBack"
      @onChangeChartTab="onChangeSuperChartTab"
    ></save-engagement-tool>
    <confirmation-dialog
      v-for="dialog in confirmationDialogList"
      :key="dialog.id"
      :dialog="dialog"
      @buttonclick="dialogButtonClock"
    ></confirmation-dialog>
  </div>
</template>

<script>
import { SaveEngagementTool } from "../../component/loan";
import { ConfirmationDialog } from "../../component/tool";
import {
  EngagementBasicScreen,
  EngagementChart,
  SuperEngagementTool,
  ICESuperIntegration,
  SuperTool,
  UserEvent,
} from "../../mixin";
import { SuperSelected, SaveAsAction } from "../../helpers/userEvent";
import {
  GET_SELECTED_SUPERANNUATION_INFORMATION,
  SET_SELECTED_SUPERANNUATION_INFORMATION,
  SET_LOADER_VISIBILITY,
  SET_ICE_PROJECTION_MODEL,
  GET_ICE_PROJECTION_MODEL,
  GET_ICE_API_RESPONSE,
  GET_SUPERANNUATION_INFORMATION,
} from "../../helpers/vuex-constants";
import { mapGetters, mapActions } from "vuex";
import { SuperannuationService } from "../../services";
export default {
  components: {
    SaveEngagementTool,
    ConfirmationDialog,
  },
  data() {
    return {
      fieldInfo: {
        label: "Superannuation Name",
        error: false,
        errorText: [],
        value: "",
        maxValue: 60,
      },
      emptyChartMessage: {
        message: "Complete Data Entry To View Graph",
      },
      pageHeadingInfo: {
        heading: "Name the instance",
        headingIconText: " test hover",
        subHeading: "Make it short and descriptive so you can easily identify",
      },

      leftToolSummary: [{ key: "Net CashFlow", value: "View Details" }],

      confirmationDialogList: [
        {
          toggle: false,
          id: 1,
          message: "You are about to discard the changes you have made.",
          title: "Discard Changes",
          leftButtons: [],
          rightButtons: [
            {
              text: "Discard",
              variation: "secondary",
              emitevent: "cancelButtonDialogDiscard_Click",
              id: 2,
            },
            {
              text: "Save",
              variation: "primary",
              emitevent: "cancelButtonDialogSave_Click",
              id: 3,
            },
          ],
        },
      ],
    };
  },
  mixins: [
    EngagementBasicScreen,
    EngagementChart,
    SuperEngagementTool,
    ICESuperIntegration,
    SuperTool,
    UserEvent,
  ],
  mounted() {
    this.projectionYear.Value = this.selectedSuperannuationData.projectionYear;
    this.RemapSuperGraphsModel();
    // this.setSuperName();
  },
  async created() {},
  computed: {
    ...mapGetters("superannuation", {
      projectionModel: GET_ICE_PROJECTION_MODEL,
      selectedSuperannuationData: GET_SELECTED_SUPERANNUATION_INFORMATION,
      getProjectionApiResponse: GET_ICE_API_RESPONSE,
      getSuperannuationInformation: GET_SUPERANNUATION_INFORMATION,
    }),
  },
  methods: {
    ...mapActions("superannuation", {
      setSelectedSuperannuationInfo: SET_SELECTED_SUPERANNUATION_INFORMATION,
      setSuperannuationChartModel: SET_ICE_PROJECTION_MODEL,
    }),
    setSuperName() {
      this.fieldInfo.value = this.selectedSuperannuationData.superannuationName;
    },

    cancelInstance() {
      this.confirmationDialogList[0].toggle = true;
    },
    dialogButtonClock(function_name) {
      this[function_name]();
    },
    saveInstance() {
      this.saveData();
    },
    onBack() {
      this.selectedSuperannuationData.isNotShowEmptyState = true;
      this.setSelectedSuperannuationInfo(this.selectedSuperannuationData);
      this.$router.push({ name: "superannuation-engagement-tool" }); //, params:{'loadChart': false}
    },
    cancelButtonDialogDiscard_Click() {
      this.selectedSuperannuationData.isNotShowEmptyState = true;
      this.$router.push({ name: "superannuation-engagement-tool" }); //, params:{loadChart:false}
    },

    ValidateInstanceName() {
      if (this.fieldInfo.value == "" || this.fieldInfo.value.trim() == "") {
        this.fieldInfo.value = "";
        this.fieldInfo.error = true;
        this.fieldInfo.errorText = ["Please Enter Instance Name"];
        return false;
      }
      var isExistName = this.getSuperannuationInformation.findIndex(
        (sr) =>
          (!sr.description ? "" : sr.description.toUpperCase().trim()) ==
          this.fieldInfo.value.toUpperCase().trim()
      );
      if (isExistName >= 0) {
        this.fieldInfo.error = true;
        this.fieldInfo.errorText = ["Instance Name aleady exist."];
        return false;
      }

      return true;
    },

    async saveData() {
      let isValid = this.ValidateInstanceName();
      let isUpdate = 0;
      if (isValid) {
        this.selectedSuperannuationData.superannuationName =
          this.fieldInfo.value;
        this.setLoaderVisibility(true);
      
          if(this.selectedSuperannuationData.superAdvanceDetails)
          {
            this.selectedSuperannuationData.superAdvanceDetails.forEach(m=> delete m.lastModifiedDate)
          }
      
        var apiResponse =
          await SuperannuationService.saveAsSuperannuationInformation(
            this.selectedSuperannuationData,
            this.getProjectionApiResponse
          );
        this.setLoaderVisibility(false);
        this.saveEngagementData(
          apiResponse,
          isUpdate == 0
            ? `Superannuation instance ${this.selectedSuperannuationData.superannuationName} has been added.`
            : `Superannuation instance ${this.selectedSuperannuationData.superannuationName} has been updated.`,
          "superannuation-instance-selection"
        );
        this.saveUserSession(SuperSelected, SaveAsAction, "");
      }
    },
    async cancelButtonDialogSave_Click() {
      this.saveData();
    },

    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
  },
  destroyed() {
    // this.setSelectedSuperannuationInfo({});
  },
};
</script>

<style lang="scss" scoped></style>
